import classNames from 'classnames';
import { FC, useState } from 'react';
import ModalDialog from '../../../shared/components/modal/ModalDialog';
import { Trans, useTranslation } from 'react-i18next';
import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Props = {
    readonly show?: boolean;
    readonly sharedSelectionlist?: boolean;
    readonly errorMessage?: string;
    readonly pendingApprovalRequest?: boolean;
    readonly sendForApproval: UseMutateFunction<void, AxiosError, string>;
    readonly hide: () => void;
};

const SendForApprovalDialog: FC<Props> = ({
    sharedSelectionlist,
    sendForApproval,
    errorMessage,
    pendingApprovalRequest,
    show,
    hide
}) => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const confirmLabel = sharedSelectionlist ? t('send') : t('confirmAndSend');

    const msgClass = classNames({
        'approval-request-error': errorMessage
    });
    const sendForApprovalClasses = classNames('lk lk-confirm', {
        'approval-disabled': pendingApprovalRequest
    });
    const cancelApprovalClasses = classNames('lk lk-primary', {
        'approval-disabled': pendingApprovalRequest
    });

    return (
        <ModalDialog show={show} title={t('reserveReports.reserveReport.viewReport.sendForApprovalTo')}>
            <input
                className="approval-input"
                type="text"
                placeholder="Email"
                onChange={event => setEmail(event.target.value)}
            />
            {sharedSelectionlist ? null : (
                <p className="mt-45">
                    <Trans i18nKey="selectionList.sendForApproval.privateInformation" components={{ b: <b /> }} />
                </p>
            )}
            <div className={msgClass}>{errorMessage}</div>
            <div className="dlb-actions">
                <a className={cancelApprovalClasses} style={{ fontWeight: 'initial' }} onClick={hide}>
                    {t('cancel')}
                </a>
                <a
                    className={sendForApprovalClasses}
                    style={{ fontWeight: 700 }}
                    onClick={() => {
                        sendForApproval(email, {
                            onSuccess: () => {
                                setEmail('');
                            }
                        });
                    }}
                >
                    {confirmLabel}
                </a>
            </div>
        </ModalDialog>
    );
};

export default SendForApprovalDialog;
